import React from "react";
import { Client as ClientBase } from "@react-fullstack/fullstack/client";
import { connect } from "socket.io-client";
import { emit } from "@react-fullstack/fullstack/shared";
class Client extends React.Component {
    constructor() {
        super(...arguments);
        this.componentDidMount = () => {
            this.socket = connect(`${this.props.host}:${this.props.port}`, this.props.socketOptions);
            this.socket.on("connect", () => {
                emit.request_views_tree(this.socket);
            });
            this.forceUpdate();
        };
        this.componentWillUnmount = () => {
            this.socket.close();
        };
        this.render = () => this.socket ? (React.createElement(ClientBase, { transport: this.socket, views: this.props.views })) : (React.createElement(React.Fragment, null, " "));
    }
}
export { Client };
//# sourceMappingURL=index.js.map